import { useState } from "react"

const useInputSet = (obj: object): [any, (field) => (val) => any] => {
  const [state, setVal] = useState(obj)
  return [state, (field) => (val) => setVal({ ...state, [field]: val })]
}

export default useInputSet
